//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import FilterSaveFormContainer from "./saveFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSaveFilterDialog() {
  const getSaveDialog = (
    handleSubmit: (values: any) => Promise<void>,
    filter?: WintSuperkollAPIModelCustomFilters.CustomFilter,
    onSubmitSuccess?: (values?: any) => void
  ): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Filter.Save),
      titleIcon: IconDefinitionConstants.WSave,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
          successMessage: TranslationKeys.Filter.SaveSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <FilterSaveFormContainer filter={filter} handleSubmit={handleSubmit} />,
      maxWidth: "sm",
      onSubmit: onSubmitSuccess,
    };
  };

  return getSaveDialog;
}

export default useSaveFilterDialog;
